/* eslint-disable import/no-anonymous-default-export */
import React, { lazy, Suspense, useEffect } from "react";
import { Route, Switch } from "react-router";
import { BrowserRouter } from "react-router-dom";
import gt4ScriptUrl from "./assets/js/gt4.js";

const Index = lazy(() => import("./pages/App.js"));
const Signup_bouns13 = lazy(() => import("./pages/signup-bouns13/index.js"));
const RV = lazy(() => import("./pages/rv/index.js"));
const BitcoinHalvingBTCC = lazy(
  () => import("./pages/bitcoin-halving-btcc/index.js"),
);
const Bwtc = lazy(() => import("./pages/bwtc/index.jsx"));
// const Deposit = lazy(() => import('./pages/deposit'))
const Win_Funds = lazy(() => import("./pages/win-funds/index.js"));
const Trading_Voucher = lazy(() => import("./pages/trading-voucher/index.js"));
const Win_Funds_KR = lazy(() => import("./pages/win-funds-kr/index.js"));
const Win_Funds_TW = lazy(() => import("./pages/win-funds-tw/index.js"));
const Exchange = lazy(() => import("./pages/exchange/index.js"));
const FreeUSDT = lazy(() => import("./pages/FreeUSDT/index.js"));
const FreeEasy = lazy(() => import("./pages/FreeEasy/index.js"));
const Bitcoin = lazy(() => import("./pages/bitcoin/index.js"));
const DepositBonus = lazy(() => import("./pages/depositBonus/index.jsx"));
const Wealth99 = lazy(() => import("./pages/wealth99/index.js"));
const CopyTrading = lazy(() => import("./pages/copytrading/index.js"));
const TwdBtc = lazy(() => import("./pages/TWDBTC/index.js"));
const BTCTWD = lazy(() => import("./pages/BTCTWD/index.js"));
const Transactionfee = lazy(() => import("./pages/transactionfee/index.jsx"));
const CopyTradingTw = lazy(() => import("./pages/copytradingTW/index.js"));
const OTC21Century = lazy(() => import("./pages/OTC21Century/index.js"));
const CopyTradingKR = lazy(() => import("./pages/copytradingKR/index.js"));
const CryptoFutures = lazy(() => import("./pages/crypto-futures/index.jsx"));
const CryptoFutures_af = lazy(
  () => import("./pages/crypto-futures-af/index.jsx"),
);
const Compensation = lazy(() => import("./pages/compensation/index.js"));
const Googlelp = lazy(() => import("./pages/googlelp/index.js"));
const Share = lazy(() => import("./pages/share/index.js"));
const Cryptodeposit_kr = lazy(
  () => import("./pages/cryptodeposit_kr/index.jsx"),
);
const Cryptodeposit2_kr = lazy(
  () => import("./pages/cryptodeposit2_kr/index.jsx"),
);
const Cryptodeposit_kr_mo = lazy(
  () => import("./pages/cryptodeposit_kr_mo/index.jsx"),
);
const Cryptodeposit_kr_moapk = lazy(
  () => import("./pages/cryptodeposit_kr_moapk/index.jsx"),
);
const Memecoin = lazy(() => import("./pages/memecoin/index.jsx"));
const Cryptodeposit_kr_adj = lazy(
  () => import("./pages/cryptodeposit_kr_adj/index.jsx"),
);
const Xmas = lazy(() => import("./pages/Xmas/index.jsx"));
const BBactivity = lazy(() => import("./pages/BBactivity/index.jsx"));
const CopyTrading_and = lazy(() => import("./pages/copytrading_and/index.js"));
const CopyTrading_af = lazy(() => import("./pages/copytrading_af/index.js"));
const copytrading_af_molocoaos = lazy(
  () => import("./pages/copytrading_af_molocoaos/index.js"),
);
const CopyTrading_reg = lazy(() => import("./pages/copytrading_reg/index.js"));
const CopyTrading_reg_reg = lazy(
  () => import("./pages/copytrading_reg/register.jsx"),
);
const Privacy = lazy(() => import("./pages/Privacy/index.jsx"));
const CopyTradingTwAf = lazy(() => import("./pages/copytradingTWAF/index.js"));
const Win_Funds_TWaf = lazy(() => import("./pages/win-funds-twAF/index.js"));
const Win_Funds_TW2 = lazy(() => import("./pages/win-funds-tw2/index.js"));
const CopyTrading_af_moloco = lazy(
  () => import("./pages/copytrading_af_moloco/index.js"),
);
const Cryptodepositcoin = lazy(
  () => import("./pages/cryptodepositcoin/index.jsx"),
);
const CryptodepositcoinMo = lazy(
  () => import("./pages/cryptodepositcoin-mo/index.jsx"),
);
const CopyTradingRu = lazy(() => import("./pages/copytradingRU/index.js"));
const Usdtofficeup = lazy(() => import("./pages/usdtofficeup/index.jsx"));
const CryptodepositcoinMoapk = lazy(
  () => import("./pages/cryptodepositcoin-moapk/index.jsx"),
);
const Officeegp = lazy(() => import("./pages/officeegp/index.jsx"));
const Officeegpmolo = lazy(() => import("./pages/officeegpmolo/index.jsx"));
const Usdtofficeup_moloc = lazy(
  () => import("./pages/usdtofficeup/moloc/index.jsx"),
);
const Usdtofficeup_fb = lazy(() => import("./pages/usdtofficeup/fb/index.jsx"));
const DepositCryptojp = lazy(() => import("./pages/DepositCryptojp/index.jsx"));
const Cryptodeposits = lazy(() => import("./pages/Cryptodeposits/index.jsx"));
const Buy_dip_crypto_af = lazy(
  () => import("./pages/buy-dip-crypto-af/index.jsx"),
);
const Memecoin_af = lazy(() => import("./pages/memecoin-af/index.jsx"));
const Creteoinvest = lazy(() => import("./pages/CreteoInvest/index.js"));
const Creteonew = lazy(() => import("./pages/CreteoNew/index.js"));
const FuturesTrading0716 = lazy(
  () => import("./pages/futures-trading0716/index.js"),
);
const Copytrading0730 = lazy(() => import("./pages/copytrading_0730/index.js"));
const Styleforum = lazy(() => import("./pages/styleforum/index.js"));
const Trusted = lazy(() => import("./pages/trusted/index.js"));
const CopyTradingMarket = lazy(
  () => import("./pages/copytrading_market/index.js"),
);
const Campaign = lazy(() => import("./pages/campaign/campaign.jsx"));
const DoubleRewards = lazy(() => import("./pages/double-rewards/index.jsx"));
const UserExclusive = lazy(() => import("./pages/userExclusive/index.tsx"));
const TopCrypto = lazy(() => import("./pages/top-crypto/index.tsx"));
const OfficeKrHomePage = lazy(() => import("./pages/office-kr/Home.tsx"));
const OfficeKrPage = lazy(() => import("./pages/office-kr/index.tsx"));
const OfficeKrIntroPage = lazy(() => import("./pages/office-kr/BTCCIntro.tsx"));
const GP0128Meta = lazy(() => import("./pages/gp0128-meta/index.tsx"));
const JPOffice = lazy(() => import("./pages/jp-office/index.tsx"));
const LearningEvolution = lazy(
  () => import("./pages/learning-evolution/index.tsx"),
);
const DepositCampaign = lazy(
  () => import("./pages/deposit-campaign/index.tsx"),
);
const Jp2026 = lazy(() => import("./pages/jp2026/index.tsx"));

export default () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = gt4ScriptUrl;
    script.type = "text/javascript";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <BrowserRouter>
      <Switch>
        <Suspense fallback={<></>}>
          <Route exact path="/" component={Index} />
          <Route
            path="/signup-bouns13/:lang(en-US|ja-JP|zh-TW|ko-KR)?/"
            component={Signup_bouns13}
          />
          <Route path="/RV/:lang(en-US|ja-JP|zh-TW|ko-KR)?/" component={RV} />
          {/* <Route  path="/deposit" component={Deposit} /> */}
          <Route
            path="/bitcoin-halving-btcc/:lang(en-US|ja-JP|zh-TW|ko-KR)?/"
            component={BitcoinHalvingBTCC}
          />
          <Route
            path="/campaign-bwtc/:lang(en-US|ja-JP|zh-TW|ko-KR)?/"
            component={Bwtc}
          />
          <Route exact path="/win-funds" component={Win_Funds} />
          <Route exact path="/trading-voucher" component={Trading_Voucher} />
          <Route exact path="/win-funds-kr" component={Win_Funds_KR} />
          <Route exact path="/win-funds-tw" component={Win_Funds_TW} />
          <Route exact path="/exchange" component={Exchange} />
          <Route exact path="/FreeUSDT" component={FreeUSDT} />
          <Route exact path="/FreeEasy" component={FreeEasy} />
          <Route exact path="/bitcoin" component={Bitcoin} />
          <Route exact path="/1000U" component={DepositBonus} />
          <Route exact path="/wealth99" component={Wealth99} />
          <Route exact path="/copytrading" component={CopyTrading} />
          <Route
            exact
            path="/copytrading-market"
            component={CopyTradingMarket}
          />
          <Route exact path="/TWDBTC" component={TwdBtc} />
          <Route exact path="/BTCTWD" component={BTCTWD} />
          <Route path="/transactionfee" component={Transactionfee} />
          <Route exact path="/copytradingTW" component={CopyTradingTw} />
          <Route exact path="/OTC21Century" component={OTC21Century} />
          <Route exact path="/copytradingKR" component={CopyTradingKR} />
          <Route exact path="/crypto-futures" component={CryptoFutures} />
          <Route exact path="/crypto-futures-af" component={CryptoFutures_af} />
          <Route exact path="/compensation" component={Compensation} />
          <Route exact path="/googlelp" component={Googlelp} />
          <Route exact path="/share" component={Share} />
          <Route exact path="/cryptodeposit-kr" component={Cryptodeposit_kr} />
          <Route
            exact
            path="/cryptodeposit2-kr"
            component={Cryptodeposit2_kr}
          />
          <Route
            exact
            path="/cryptodeposit-kr-mo"
            component={Cryptodeposit_kr_mo}
          />
          <Route
            exact
            path="/cryptodeposit-kr-moapk"
            component={Cryptodeposit_kr_moapk}
          />
          <Route exact path="/memecoin" component={Memecoin} />
          <Route exact path="/memecoin-af" component={Memecoin_af} />
          <Route
            exact
            path="/cryptodeposit-kr-adj"
            component={Cryptodeposit_kr_adj}
          />
          <Route exact path="/Xmas" component={Xmas} />
          <Route exact path="/BBactivity" component={BBactivity} />
          <Route exact path="/copytrading-AND" component={CopyTrading_and} />
          <Route exact path="/copytrading-af" component={CopyTrading_af} />
          <Route
            exact
            path="/copytrading_af_molocoaos"
            component={copytrading_af_molocoaos}
          />
          <Route exact path="/copytrading-reg" component={CopyTrading_reg} />
          <Route
            exact
            path="/copytrading-register"
            component={CopyTrading_reg_reg}
          />
          <Route exact path="/Privacy" component={Privacy} />
          <Route exact path="/copytradingTWAF" component={CopyTradingTwAf} />
          <Route exact path="/win-funds-twAF" component={Win_Funds_TWaf} />
          <Route exact path="/win-funds-tw2" component={Win_Funds_TW2} />
          <Route
            exact
            path="/copytrading-af-moloco"
            component={CopyTrading_af_moloco}
          />
          <Route
            exact
            path="/cryptodepositcoin"
            component={Cryptodepositcoin}
          />
          <Route
            exact
            path="/cryptodepositcoin-mo"
            component={CryptodepositcoinMo}
          />
          <Route
            exact
            path="/cryptodepositcoin-coinness"
            component={CryptodepositcoinMo}
          />
          <Route exact path="/copytrading-RUS" component={CopyTradingRu} />
          <Route exact path="/usdtofficeup" component={Usdtofficeup} />
          <Route
            exact
            path="/cryptodepositcoin-moapk"
            component={CryptodepositcoinMoapk}
          />
          <Route exact path="/officeegp" component={Officeegp} />
          <Route exact path="/officeegpmolo" component={Officeegpmolo} />
          <Route
            exact
            path="/usdtofficeup/moloc"
            component={Usdtofficeup_moloc}
          />
          <Route exact path="/usdtofficeup/fb" component={Usdtofficeup_fb} />
          <Route exact path="/DepositCryptojp" component={DepositCryptojp} />
          <Route exact path="/Cryptodeposits" component={Cryptodeposits} />
          <Route
            exact
            path="/buy-dip-crypto-af"
            component={Buy_dip_crypto_af}
          />
          <Route exact path="/creteoinvest" component={Creteoinvest} />
          <Route exact path="/creteonew" component={Creteonew} />
          <Route
            exact
            path="/futuresTrading0716"
            component={FuturesTrading0716}
          />
          <Route exact path="/copytrading0730" component={Copytrading0730} />
          <Route exact path="/styleforum" component={Styleforum} />
          <Route
            exact
            path="/:lang(en-US|de-DE)?/trusted"
            component={Trusted}
          />
          <Route exact path="/campaign" component={Campaign} />
          <Route
            exact
            path="/campaign/doublerewards"
            component={DoubleRewards}
          />
          <Route exact path="/userExclusive" component={UserExclusive} />
          <Route exact path="/topCrypto" component={TopCrypto} />
          <Route
            path="/officekr"
            render={(routeProps) => (
              <OfficeKrHomePage {...routeProps}>
                <Switch>
                  {/* /:lang?/officekr 主页 */}
                  <Route
                    exact
                    path={routeProps.match.path}
                    component={OfficeKrPage}
                  />
                  {/* /:lang?/officekr/btcc-intro 子页 */}
                  <Route
                    path={`${routeProps.match.path}/btcc-intro`}
                    component={OfficeKrIntroPage}
                  />
                </Switch>
              </OfficeKrHomePage>
            )}
          />
          <Route
            path="/officekr01"
            render={(routeProps) => (
              <OfficeKrHomePage {...routeProps}>
                <Switch>
                  {/* /:lang?/officekr 主页 */}
                  <Route
                    exact
                    path={routeProps.match.path}
                    component={OfficeKrPage}
                  />
                  {/* /:lang?/officekr/btcc-intro 子页 */}
                  <Route
                    path={`${routeProps.match.path}/btcc-intro`}
                    component={OfficeKrIntroPage}
                  />
                </Switch>
              </OfficeKrHomePage>
            )}
          />
          <Route exact path="/BTCC-GP0128-meta" component={GP0128Meta} />
          <Route exact path="/btccjpoffice" component={JPOffice} />
          <Route exact path="/btccjpoffice01" component={JPOffice} />
          <Route
            exact
            path="/learningEvolution"
            component={LearningEvolution}
          />
          <Route
            exact
            path="/:lang(en-US|en-CA)?/deposit-campaign"
            component={DepositCampaign}
          />
          <Route exact path="/jp2026" component={Jp2026} />
        </Suspense>
      </Switch>
    </BrowserRouter>
  );
};
